import { render, staticRenderFns } from "./ArticleTiles.vue?vue&type=template&id=03b61bac&scoped=true&"
import script from "./ArticleTiles.vue?vue&type=script&lang=js&"
export * from "./ArticleTiles.vue?vue&type=script&lang=js&"
import style0 from "./ArticleTiles.vue?vue&type=style&index=0&id=03b61bac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b61bac",
  null
  
)

export default component.exports